import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import {
  SunLifeBrokerPageStore,
  SunLifeBrokerPageStoreContext,
} from 'store/pages/enrollment/broker/broker-sunlife/pageStore';
import PageContent from 'components/enrollment/broker/broker-sunlife';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const SunLifeBrokerPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new SunLifeBrokerPageStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <ProposalStatusLayout>
      <SunLifeBrokerPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </SunLifeBrokerPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default observer(SunLifeBrokerPage);
